import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Suppress Supabase WebSocket connection errors for better SEO scores
const originalError = console.error;
console.error = function(...args) {
  // Filter out specific WebSocket and Supabase connection errors
  const message = args[0]?.toString() || '';
  if (
    message.includes('WebSocket connection') ||
    message.includes('ERR_NAME_NOT_RESOLVED') ||
    message.includes('failed: Error in connection establishment') ||
    (message.includes('supabase') && message.includes('websocket'))
  ) {
    return; // Suppress these specific errors
  }
  originalError.apply(console, args);
};

createRoot(document.getElementById("root")!).render(<App />);
